<div class="layout-auto-1-auto">
  <div></div>
  <div class="content">
    <h5>Ablaufplanvorlagen</h5>
    <div class="grid cols-6">
      <div class="span-3">
        <exg-select #typSelector [list]="enmSvc.getEnumerationList('VorgangTyp')" listdisplay="enmText" caption="Vorgangstyp" (ngModelChange)="changeType($event)" [ngModel]="value"></exg-select>
      </div>
      <div class="span-3">
        <label class="fs-small">{{selectedTypeIdent}} Bitte wählen Sie den Vorgangstyp und den Mandanten aus um das entsprechende Template für den Ablaufplan bearbeiten zu können.</label>
      </div>
    </div>
  </div>
  <div></div>
</div>
